import React, { useEffect, useRef, useState } from 'react';

const Mission = () => {
  const [isVisible, setIsVisible] = useState(false);
  const missionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
        });
      },
      { threshold: 0.40 }
    );

    if (missionRef.current) {
      observer.observe(missionRef.current);
    }
  }, [missionRef]);

  return (
    <div ref={missionRef} className='bg-img-bg bg-repeat'>
      <div className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 md:px-8 mid-lg:px-16 lg:px-24 bg-colour bg-opacity-95 flex flex-col md:flex-row justify-center gap-6 md:gap-8 lg:gap-12">
        <div className={`flex flex-col justify-center flex-1 transition-all duration-1000 ${isVisible ? 'animate-slideInTop' : ''}`}>
          <div>
            <h1 className='text-2xl sm:text-3xl md:text-4xl font-light tracking-wider'>OUR MISSION</h1>
          </div>
        </div>
        <div className={`tracking-wide flex flex-col justify-center flex-1 transition-all duration-1000 ${isVisible ? 'animate-slideInTop1' : ''}`}>
          <div>
            <p className='text-xs sm:text-sm md:text-base leading-relaxed text-gray-800'>
              Haideries, is a Dubai-based real estate, bespoke luxury events and experiences company, Our goal is to be the foremost facilitator of exceptional real estate experiences and hosting MICE globally in the vibrant and ever-evolving landscape of Dubai and globally. We are dedicated to redefining the way people buy, sell, and invest in real estate in this dynamic city and curated luxury experiences for our high end clientele.
            </p>
          </div>
        </div>
        <div className={`tracking-wide flex flex-col justify-center flex-1 transition-all duration-1000 ${isVisible ? 'animate-slideInTop2' : ''}`}>
          <div>
            <p className='text-xs sm:text-sm md:text-base leading-relaxed text-gray-800'>
              Our core values of client-centricity, innovation, and integrity drive us to prioritize our clients’ unique needs and aspirations above all else. We continuously embrace innovative technologies and stay at the forefront of market trends to provide our clients with the most insightful and effective solutions.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mission;
